'use strict';

angular.module('theme').filter('pt', function ($filter, $translate) {
	var number = $filter('number');

	return function (amount, fract, nullValue) {
		if (!amount) {
			return nullValue;
		}
		return number(amount, angular.isUndefined(fract) ? 0 : fract) + ' ' + $translate.instant('THEME.PRODUCT.PORTIONS');
	};
});
